var _defs, _g, _g2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTradierLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 232.59 107.72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{clip-path:url(#clip-path);}.cls-3{fill:#77838f;}.cls-4{clip-path:url(#clip-path-4);}.cls-5{fill:#ffd776;}.cls-6{fill:#f6b350;}.cls-7{fill:#e39196;}.cls-8{fill:#99bee5;}.cls-9{fill:#c44260;}.cls-10{fill:#9d2951;}.cls-11{fill:#4797d1;}.cls-12{fill:#0c72af;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path",
    transform: "translate(-14.11 -12.73)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: -160,
    y: -280,
    width: 612,
    height: 792
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4",
    transform: "translate(-14.11 -12.73)"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "195.64 15.01 179.26 31.3 208.56 31.3 179.83 60.03 192.71 72.82 221.41 44.1 221.41 73.36 237.78 57.08 237.78 15.01 195.64 15.01"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "18.43 106.56 6.01 106.56 6.01 81.8 0 81.8 0 71.57 6.01 71.57 6.01 60.35 18.43 60.35 18.43 71.57 25.45 71.57 25.45 81.8 18.43 81.8 18.43 106.56"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M55.93,90h.14c2.39-4.3,6.48-6.21,11.32-6.21h2.39V95.75a10.09,10.09,0,0,0-5.25-1.16c-6.89,0-8.6,4.57-8.6,10.57v14.12H43.52v-35H55.93Z",
    transform: "translate(-14.11 -12.73)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M112.45,119.28H100V115.4H99.9c-2.18,3.48-6.48,5-10.57,5-10.37,0-17.67-8.67-17.67-18.69s7.16-18.63,17.53-18.63c4,0,8.26,1.5,10.85,4.57V84.29h12.41Zm-28-17.46c0,4.44,2.94,7.85,8,7.85s8-3.41,8-7.85a8,8,0,0,0-16,0",
    transform: "translate(-14.11 -12.73)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M143.92,115.4h-.14c-2.18,3.48-6.48,5-10.57,5-10.37,0-17.67-8.67-17.67-18.69s7.16-18.63,17.53-18.63c4,0,8.26,1.5,10.85,4.57v-25h12.41v56.61H143.92Zm-15.56-13.58c0,4.44,2.94,7.85,8,7.85s8-3.41,8-7.85a8,8,0,0,0-16,0",
    transform: "translate(-14.11 -12.73)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M175.2,70.85a7,7,0,1,1-7-6.95,7,7,0,0,1,7,6.95m-.75,48.43H162v-35h12.42Z",
    transform: "translate(-14.11 -12.73)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M217.21,103.87H191.09c0,5,2.66,7.78,7.77,7.78a6.22,6.22,0,0,0,5.94-3.21h11.93a14.28,14.28,0,0,1-6.61,9.07,21.4,21.4,0,0,1-11.19,2.94c-11.59,0-20.26-6.55-20.26-18.63,0-11.66,8-18.69,19.38-18.69,12.14,0,19.16,7.51,19.16,19.45Zm-11.53-7.16a7,7,0,0,0-7-5.53c-3.62,0-6.62,1.91-7.37,5.53Z",
    transform: "translate(-14.11 -12.73)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M232.85,90H233c2.39-4.3,6.48-6.21,11.32-6.21h2.39V95.75a10.09,10.09,0,0,0-5.25-1.16c-6.89,0-8.6,4.57-8.6,10.57v14.12H220.44v-35h12.41Z",
    transform: "translate(-14.11 -12.73)"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "165.15 58.8 217.98 7.92 193.31 65.89 165.15 58.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "171.49 54.35 164.56 47.23 192.24 19.23 217.98 7.92 171.49 54.35"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "162.49 20.11 166.53 16.23 217.99 7.92 194.45 18.58 162.49 20.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "207.3 31.37 217.99 7.92 208.96 60.63 207.77 61.78 205.9 60.63 207.3 31.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "217.98 7.92 165.15 18.58 180.99 1.29 217.98 7.92"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "181.52 2.28 188.12 0 224.61 1.73 218.26 7.96 181.52 2.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "207.3 60.63 217.99 7.92 226.15 46.67 207.3 60.63"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "223.67 44.35 217.98 7.92 223.67 2.28 226.56 39.35 223.67 44.35"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTradierLogo);
export default __webpack_public_path__ + "static/media/tradier-logo.19c7048715e6adf467a79d6a4b0bd6d5.svg";
export { ForwardRef as ReactComponent };